import { render, staticRenderFns } from "./JcomTableMembersEdit.vue?vue&type=template&id=64eb1856"
import script from "./JcomTableMembersEdit.vue?vue&type=script&lang=js"
export * from "./JcomTableMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomTableMembersEdit.vue?vue&type=style&index=0&id=64eb1856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports